// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"db1d662d","988":"106e3537"}[chunkId] + ".chunk.js";
};